import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-biometry-create',
  templateUrl: './biometry-create.component.html',
  styleUrls: ['./biometry-create.component.sass']
})
export class BiometryCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
